import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Tags } from 'lucide-react';
import MainLayout from '../../../app/layouts/MainLayout';
import { Card } from '../../../components/ui/Card';

const moreItems = [
  {
    label: 'Segmentos',
    description: 'Cadastre segmentos e faixas etárias.',
    icon: Tags,
    path: '/segmentos',
    tone: 'from-sky-100 to-cyan-100 text-sky-700',
  },
];

const MorePage = () => {
  return (
    <MainLayout>
      <div className="space-y-6">
        <header>
          <h2 className="text-2xl font-bold text-slate-900">Mais</h2>
          <p className="text-sm text-gray-500">Acesse recursos adicionais da plataforma.</p>
        </header>

        <div className="space-y-3">
          {moreItems.map(({ label, description, icon: Icon, path, tone }) => (
            <Link key={path} to={path} className="block">
              <Card className="flex items-center gap-4 border-slate-200 p-4 transition-shadow hover:shadow-md">
                <div className={`rounded-2xl bg-gradient-to-br ${tone} p-3`}>
                  <Icon size={22} />
                </div>
                <div className="flex-1">
                  <p className="text-base font-semibold text-slate-900">{label}</p>
                  <p className="text-sm text-gray-500">{description}</p>
                </div>
                <ChevronRight size={20} className="text-gray-400" />
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default MorePage;
